import { useContext } from "react";

import HelpContext from "src/contexts/help/HelpContext";

/**
 * Returns the help panel and tour controls from the nearest help context.
 *
 * Postconditions: Uses the inert context default without a provider; reading the context does not
 * open help or start a tour.
 */
const useHelp = () => useContext(HelpContext);

export default useHelp;
